import React from 'react';
import './Upcomingevents.css';

const events = [
  {
    id: 1,
    title: "Authors Meet & Greet",
    time: "Today, 3:00 PM",
    attendees: 145,
    color: '#AD4D34',
  },
  {
    id: 2,
    title: "Creative Writing Workshop",
    time: "Tomorrow, 11:00 AM",
    attendees: 89,
    color: '#545E48',
  },
  {
    id: 3,
    title: "Rare Books Exhibition",
    time: "Tomorrow, 2:00 PM",
    attendees: 234,
    color: '#8B6914',
  },
];

export default function UpcomingEvents() {
  return (
    <div className="events-card">
      <div className="events-header">
        <span className="events-title">Upcoming Events</span>
        <button className="events-view-all">View all</button>
      </div>
      <div className="events-list">
        {events.map((event, idx) => (
          <div key={event.id} className="event-item">
            <div className="event-indicator" style={{ background: event.color }} />
            <div className="event-info">
              <span className="event-name">{event.title}</span>
              <span className="event-time">{event.time}</span>
            </div>
            <div className="event-attendees">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
              <span>{event.attendees}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}